// src/sectors/pilates/sessions/components/SessionDetailDialog/SessionDetailMenu.jsx
import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { alpha, useTheme as useMuiTheme } from '@mui/material/styles';

export function SessionDetailMenu({
  anchorEl,
  open,
  onClose,
  isPaid,
  onEdit,
  onPayment,
  onCancel,
}) {
  const theme = useMuiTheme();
  const isDark = theme.palette.mode === 'dark';
  const borderSoft = `1px solid ${alpha(theme.palette.text.primary, isDark ? 0.14 : 0.1)}`;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          mt: 1,
          border: borderSoft,
          background: isDark ? alpha('#0b1220', 0.92) : alpha('#fff', 0.98),
          backdropFilter: 'blur(8px)',
          minWidth: 230,
        },
      }}
    >
      <MenuItem onClick={onEdit}>
        <ListItemIcon>
          <Icon fontSize="small">edit</Icon>
        </ListItemIcon>
        <ListItemText primary="Düzenle" />
      </MenuItem>

      {isPaid ? (
        <MenuItem onClick={onPayment}>
          <ListItemIcon>
            <Icon fontSize="small">credit_card</Icon>
          </ListItemIcon>
          <ListItemText primary="Ödeme Al" />
        </MenuItem>
      ) : null}

      <Divider />

      <MenuItem onClick={onCancel} sx={{ color: theme.palette.error.main }}>
        <ListItemIcon>
          <Icon fontSize="small" sx={{ color: theme.palette.error.main }}>
            event_busy
          </Icon>
        </ListItemIcon>
        <ListItemText primary="Seansı İptal Et" />
      </MenuItem>
    </Menu>
  );
}
